import {Fragment, useEffect, useState} from "react";
import { useForm, Controller } from "react-hook-form";
import NotificationsApi from '~/api/notificationsApi';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import Table from '~/components/Table';
import {CenteredModal} from "~/components";
import { toast } from 'react-toastify';

function NotificationTab({ title }) {
    const [data, setData] = useState([]);
    const [isUpdateConfig, setIsUpdateConfig] = useState(true);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [payload, setPayload] = useState([]);
    const { control, handleSubmit, reset, watch } = useForm();

    useEffect(() => {
        NotificationsApi.getUserSettings("0")
            .then((res) => {
                setData(res.data);
                reset(res.data.reduce((acc, item) => {
                    acc[`${item.UserNotiSettingId}_InApp`] = item.InApp;
                    acc[`${item.UserNotiSettingId}_Email`] = item.Email;
                    return acc;
                }, {}));
            })
            .catch(() => {});
    }, [reset]);

    const columns = [
        {
            name: 'ID',
            width: '50px',
            key: 'NotificationEventId',
            template: (row) => <span className="fw-bold">{row.NotificationEventId}</span>,
        },
        {
            name: 'EVENT NAME',
            width: '200px',
            key: 'EventName',
            className: 'fw-bold',
        },
        {
            name: 'EVENT DESCRIPTION',
            width: '300px',
            key: 'EventDescription',
        },
        {
            name: 'IN_APP',
            width: '100px',
            key: 'InApp',
            template: (row) => (
                <div className="fs-8">
                    <Controller
                        name={`${row.UserNotiSettingId}_InApp`}
                        control={control}
                        render={({ field }) => (
                            <input
                                type="checkbox"
                                className="form-check-input"
                                disabled={isUpdateConfig}
                                checked={field.value || false}
                                onChange={(e) => field.onChange(e.target.checked)}
                            />
                        )}
                    />
                </div>
            ),
        },
        {
            name: 'EMAIL',
            width: '100px',
            key: 'Email',
            template: (row) => (
                <div className="fs-8">
                    <Controller
                        name={`${row.UserNotiSettingId}_Email`}
                        control={control}
                        render={({ field }) => (
                            <input
                                type="checkbox"
                                className="form-check-input"
                                disabled={isUpdateConfig}
                                checked={field.value || false}
                                onChange={(e) => field.onChange(e.target.checked)}
                            />
                        )}
                    />
                </div>
            ),
        },
    ];

    const onSubmit = (values) => {
        const payload = data.map((item) => ({
            NotificationEventId: item.NotificationEventId,
            UserNotiSettingId: item.UserNotiSettingId,
            InApp: values[`${item.UserNotiSettingId}_InApp`] || false,
            Email: values[`${item.UserNotiSettingId}_Email`] || false,
        }));
        setPayload(payload);
        setShowConfirmModal(true);
    };

    const handleConfirmChange = () => {
        NotificationsApi.insUpdUserSetting(payload)
            .then((res) => {
                res.data?.Success ?
                    toast.success(<span className="fs-9 fw-bold">Your notification setting has been updated.</span>)
                    : toast.error(<span className="fs-9 fw-bold">An error occurred while updating your notification setting.</span>)
            })
            .catch((err) => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating your notification setting.</span>)
            })
            .finally(() => {
                setShowConfirmModal(false);
                setPayload([]);
            })
    }

    return (
        <Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-6">
                    <h4 className="mb-4 text-center">{title}</h4>
                    <Table tableConfig={{ columns, data }} />
                    <div className="text-center mb-6 mt-4">
                        {!isUpdateConfig && (
                            <button
                                type="button"
                                className="btn btn-bt-secondary me-2"
                                onClick={() => {
                                    setIsUpdateConfig(true);
                                    reset();
                                }}
                            >
                                Cancel
                            </button>
                        )}
                        {isUpdateConfig && (
                            <button
                                type="button"
                                className="btn btn-bt-primary me-2"
                                onClick={() => setIsUpdateConfig(false)}
                            >
                                Edit
                                <FontAwesomeIcon className="ms-3" icon={faPen} />
                            </button>
                        )}
                        <button
                            type="submit"
                            disabled={isUpdateConfig}
                            className="btn btn-bt-secondary"
                        >
                            Save Change Settings
                        </button>
                    </div>
                </div>
            </form>
            <CenteredModal show={showConfirmModal}
                           onClose={() => setShowConfirmModal(false)}
                           title="Confirm Change Notification Settings"
                           confirmText="Save Changes"
                           onConfirm={handleConfirmChange}
            >
                <div>
                    <span className="fs-8-1 fw-bold">Are you sure you want to change notification setting?</span>
                </div>
            </CenteredModal>
        </Fragment>
    );
}

export default NotificationTab;
